import { Component, HostBinding, Input } from '@angular/core';

import { EmployeeModel } from '../../../../../../reducers/orm/employee/employee.model';
import { defaultTotal } from '../../../../../../shared/total.helper';

@Component({
  standalone: false,
  selector: 'timesheet-employee',
  templateUrl: './timesheet-employee.component.html',
})
export class TimesheetEmployeeComponent {
  @Input()
  employee: EmployeeModel;
  @Input()
  approvedTotal = defaultTotal;
  @Input()
  showSalary: boolean;
  @Input()
  canViewEmployee = true;
  @Input()
  scheduleDiff: number;
  @Input()
  show = true;
  @Input()
  last = true;
  @Input()
  teamId: string;

  @HostBinding('style.height.px')
  height = 36;
}
